import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FunctionalGroupEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes, MainCatalogTypes } from "../../_loadingHelpers/MainCatalogTypes";

import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import lang from 'dojo/_base/lang';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FunctionalSubGroupEntryV2 from './FunctionalSubGroup/FunctionalSubGroupEntryV2';

class FunctionalGroupEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    functionalMainGroupSelect: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;
    selectContainer: HTMLDivElement;

    subGroupExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    subGroupStore: MdsLax<InstanceType<typeof EntityStore<MainCatalogTypes.FunctionalSubGroup_SaveData>>>;
    subGroupTable: MdsLax<InstanceType<typeof StaticTable>>;

    tableRowLayout: StaticTable.RowConfig = {
        attributes: ["order", "code", "description"],
        colNamesInternal: ["order", "code", "description"],
        headings: [(this as any).translate("General_Label_Order"), (this as any).translate("General_Label_Code"), (this as any).translate("General_Label_Description")],
        colspans: [1, 1, 4],
    }

    tableLayout: StaticTable.Layout = {
        label: "subGroupTable",
        name: "subGroupTable",
        rows: [(this as any).tableRowLayout],
    }


    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        var functionalMainGroup = this.getAttributeValue("ref_functional_main_group.ID");

        this.functionalMainGroupSelect.setCatalog(MainCatalogs_Classes.FunctionalMainGroup,
            this.translations["General_Label_FunctionalMainGroup"], functionalMainGroup);

        var subGroups = this.getAttributeValue("EL_functional_sub_group_functional_group");
        subGroups.sort((a, b) => {
            return a.order - b.order;
        });
        this.subGroupStore.setup(subGroups);
        this.subGroupTable.setupFromStore(this.subGroupStore);

        this.subGroupExpander.setMarking(subGroups.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

    }

    private _setupTable(): void {
        this.subGroupTable = new StaticTable();
        this.subGroupTable.addLayout(this.tableLayout);
        //this.subGroupTable.addDefaultRowActionButton("delete");
        this.subGroupTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.subGroupTable.setupFromStore(this.subGroupStore);
        this.subGroupTable.setCyAttribute("FunctionalGroupEditorV2SubGroupTable");

        this.subGroupTable.placeAt(this.subGroupExpander);
    }

    private _onClickTableRow(e): void {
        console.log(e);

        var entity = e.rowGroup.entity;

        var subGroupEditor = new FunctionalSubGroupEntryV2();
        subGroupEditor.setEntry(entity.is_new_status, entity);

        var dlg = new GenericDialog();
        dlg.keepOpen = true;
        dlg.show(subGroupEditor, entity._displayname, null, null, "okcancel", lang.hitch(this, this._onDlgResponse, dlg, subGroupEditor));
    }

    private _onClickButtonSubGroupAdd(e) {
        var subGroupEditor = new FunctionalSubGroupEntryV2();
        subGroupEditor.setEntry(true);


        var dlg = new GenericDialog();
        dlg.keepOpen = true;
        dlg.show(subGroupEditor, "MainCatalogsEditor_FunctionalSubGroup_NewEntryHeader", null, null, "okcancel", lang.hitch(this, this._onDlgResponse, dlg, subGroupEditor));
        
    }

    private _sortStore(): void {

    }

    private _onDlgResponse(dlg: MdsLax<InstanceType<typeof GenericDialog>>, editor: MdsLax<InstanceType<typeof FunctionalSubGroupEntryV2>>, response: number) {
        if (response === 1) {
            var data = editor.formData;
            if (data.is_new_status) {
                this.subGroupStore.addEntry(data);
            } else {
                this.subGroupStore.changeEntry(data);
            }

            
            dlg.close();
        } else {
            dlg.close();
        }
    }

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.FunctionalGroup;
    }

    private _onChangeSelect(): void {
        var value = this.functionalMainGroupSelect.getValue();
        this.setAttributeValue("ref_functional_main_group", value, true);
    }

    private _onChangeStore(): void {
        var subGroupDiffData = this.subGroupStore.getDiffData();
        this.setAttributeValue("subGroupDiffData", subGroupDiffData);

        this.subGroupExpander.setMarking(this.subGroupStore.getCurrentCompleteList().length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //Deactivate delete
        this.privilegeName_Delete = "";

        this.functionalMainGroupSelect = new MainCatalogSelectV2();
        this.functionalMainGroupSelect.setReadonly();

        this.functionalMainGroupSelect.placeAt(this.selectContainer);
        this.functionalMainGroupSelect.on("change", lang.hitch(this, this._onChangeSelect));

        this.functionalMainGroupSelect.setCatalog(MainCatalogs_Classes.FunctionalMainGroup,
            this.translations["General_Label_RoomType"]);

        this.subGroupStore = new EntityStore();
        this.subGroupStore.on("change", lang.hitch(this, this._onChangeStore));
        this._setupTable();

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FunctionalGroupEditorV2);